import { css } from '@bts-web/utils-style-engine';
import { RegularNothingToShow } from '../../svgIcons';

export const nothingContainerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: 'auto',
});

export const nothingImageStyle = css({
  marginBottom: 'small',
  color: 'neutrals.text_disabled',
});

export const nothingTextStyle = css({
  fontSize: 'label.medium_medium',
  lineHeight: 'label.medium_medium',
  letterSpacing: 'label.medium_medium',
  fontWeight: 'label.medium_medium',
  color: 'neutrals.text_disabled',
});

export const NothingToShow = ({ text }: { text: string }) => {
  return (
    <div className={nothingContainerStyle} data-testid="nothing-to-show">
      <RegularNothingToShow
        size={28}
        color="text_disabled"
        className={nothingImageStyle}
      />
      <span className={nothingTextStyle}>{text}</span>
    </div>
  );
};
